import {Injectable} from "@angular/core";
import {Action} from "@ngrx/store";
import {Actions, createEffect, ofType} from "@ngrx/effects";
import {Observable, of} from "rxjs";
import {debounceTime, map, mergeMap} from "rxjs/operators";
import {AppActionTypes, LocaleUpdated, RefreshTokenRequest} from "../actions";
import {TranslateService} from "@ngx-translate/core";
import {TranslationService as SolTranslationService} from "@niceltd/sol/translation";
import {AuthenticationService} from "src/app/authentication.service";
import { HttpClient } from "@angular/common/http";
import {TenantService} from 'src/app/tenant.service';
import {localeFallback} from '../../common/utils/localeFallback';

@Injectable()
export class AppEffects {

  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private translateService: TranslateService,
    private solTranslationService: SolTranslationService,
    private tenantService: TenantService
  ) {
  }

  requestSuccessful$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(AppActionTypes.RequestSuccessful),
    map((action: RefreshTokenRequest) => action.payload),
    mergeMap((payload: any) => {
      return this.authenticationService.refreshTokenIfNecessary();
    })
  ));

  UpdateLocale$: Observable<Action> = createEffect(() => this.actions$.pipe(
    ofType(AppActionTypes.UpdateLocale),
    debounceTime(500),
    map((action: LocaleUpdated) => action.payload),
    mergeMap((payload: any) => {
      let targetLang = payload
      if (payload) {
        targetLang = localeFallback(targetLang);

        if(targetLang!==this.translateService.currentLang) {
          this.solTranslationService.setLocale(targetLang);
          return this.translateService.use(targetLang).pipe(
            map(() => {
              return {type: AppActionTypes.LocaleUpdated, payload: true};
            })
          );
        }
        return of({type: AppActionTypes.LocaleUpdated, payload: true});
      }
      return of({type: AppActionTypes.LocaleUpdated, payload: false});
    })
  ));
}

